<template>
  <div class="confirm-action">
    <div class="label">
      <h3>{{ title }}</h3>
    </div>
    <div class="form form--sidepanel">
      <div class="form-group">
        <p class="message">{{ message }}</p>
        <slot />
      </div>
      <div class="form-footer">
        <button v-if="showCancel" type="button" class="btn btn-default" @click="onCancel">{{ $t("form.button.cancel") }}</button>
        <button v-if="showConfirm" type="submit" :class="['btn', confirmButtonClass]" @click="onConfirm">{{ $t("form.button.confirm") }}</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        require: true
      },
      message: {
        type: String,
        require: true
      },
      confirmButtonClass: {
        type: String,
        default: () => "btn-carma"
      }
    },
    computed: {
      showCancel () {
        return this.$listeners && this.$listeners.cancel;
      },
      showConfirm () {
        return this.$listeners && this.$listeners.confirm;
      }
    },
    methods: {
      onCancel () {
        this.$emit("cancel");
      },
      onConfirm () {
        this.$emit("confirm");
      }
    }
  }
</script>
<style lang="scss">
  .confirm-action .message {
    white-space: pre-line;
  }
</style>